/* eslint-disable */
export default {
  forward: 'Reenviar',
  reply: 'Responder',
  ignore: 'Ignorar',
  toVoicemail: 'Enviar al buzón de voz',
  answer: 'Responder',
  answerAndEnd: 'Resp. y finalizar',
  answerAndHold: 'Resp. y poner en espera',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
